import type { ChangeRequestRegisterWithUserFieldsRow } from '@risksmart-app/drizzle/src/dto';

import { callerOwnerGrants } from './callerOwnerGrants';

/**
 * Maps the slim tRPC register rows back to the legacy GraphQL query shape.
 * The display-only `parentOwners` field is derived from the concrete parent
 * relations by `useLabelledFields`; it is not part of the GraphQL selection.
 * The caller's own owner grants are mirrored onto every node the owner walk
 * visits — see `callerOwnerGrants`.
 */
export const mapChangeRequestRegisterRowsToGraphQl = (
  rows: ChangeRequestRegisterWithUserFieldsRow[]
) => ({
  change_request: rows.map((item) => {
    const currentUserOwners = callerOwnerGrants(item.currentUserOwnerList);

    return {
      ...item,
      responses: item.responses.flatMap((response) =>
        response.approver ? [{ ...response, approver: response.approver }] : []
      ),
      parent: item.parent
        ? {
            ...item.parent,
            currentUserOwners,
            documentFile: item.document_file
              ? {
                  Version: item.document_file.Version,
                  parent: item.document_file.parent
                    ? { ...item.document_file.parent, currentUserOwners }
                    : null,
                }
              : null,
            acceptance: item.acceptance
              ? {
                  ...item.acceptance,
                  parents: item.acceptance.parents.map((acceptanceParent) => ({
                    ...acceptanceParent,
                    risk: acceptanceParent.risk
                      ? { ...acceptanceParent.risk, currentUserOwners }
                      : null,
                  })),
                }
              : null,
            risk: item.risk,
            control: item.control,
            action: item.action,
            issue_assessment: item.issue_assessment
              ? {
                  ...item.issue_assessment,
                  parent: item.issue_assessment.parent
                    ? { ...item.issue_assessment.parent, currentUserOwners }
                    : null,
                }
              : null,
          }
        : null,
    };
  }),
});
